import React, { FunctionComponent, createContext, useContext, useState, useCallback } from 'react';
import array from '@modules/ui/shared/utils/array';
import { addOrRemoveStateElement } from '@modules/ui/shared/components/AppMainConfigProvider';

export type AppMainStateType = {
  accordionsExpanded: string[];
  setAccordionExpanded: (accordionId: string, value: boolean) => void;
  setAccordionsExpanded: (ids: string[]) => void;
};

const AppMainStateContext = createContext<AppMainStateType>({
  accordionsExpanded: [],
  setAccordionExpanded: () => {
    throw Error('not implemented');
  },
  setAccordionsExpanded: () => {
    throw Error('not implemented');
  },
});
AppMainStateContext.displayName = 'AppMainState';

export function useAppMainState() {
  return useContext(AppMainStateContext);
}

const AppMainStateProvider: FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [accordionsExpanded, _setAccordionsExpanded] = useState<string[]>([]);

  const setAccordionsExpanded = useCallback((accordionIds: string[]) => {
    _setAccordionsExpanded((ids) => {
      if (array.hasSameElements(accordionIds, ids)) {
        return ids;
      }
      return array.removeDuplicate(accordionIds);
    });
  }, []);

  const setAccordionExpanded = useCallback((accordionId: string, value: boolean) => {
    _setAccordionsExpanded((ids) => addOrRemoveStateElement(ids, accordionId, value));
  }, []);

  return (
    <AppMainStateContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{ accordionsExpanded, setAccordionExpanded, setAccordionsExpanded }}>
      {children}
    </AppMainStateContext.Provider>
  );
};

export default AppMainStateProvider;
